import config from 'config';

export function getFreeShippingThresholds({
  isVip,
  isVipCart,
  isInPostRegWindow,
}) {
  const freeShippingConfig = config.get('public.brand.freeShipping');

  if (freeShippingConfig.config === 'user') {
    const freeShippingThresholds = {};
    for (const cfgGroup of freeShippingConfig.byUser) {
      for (let i = 0; i < cfgGroup.tlds.length; i++) {
        let userType = 'Paygo';
        if (isVip) {
          userType = 'Vip';
        } else {
          if (isVipCart) {
            if (isInPostRegWindow) {
              userType = 'ActivatingPostReg';
            } else {
              userType = 'ActivatingAfterPostReg';
            }
          }
        }
        freeShippingThresholds[cfgGroup.tlds[i]] = {
          label: cfgGroup.labels[i],
          shippingThreshold: cfgGroup[userType],
        };
      }
    }

    return freeShippingThresholds;
  }

  return freeShippingConfig.byCountry;
}
